import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../../types/redux';
import Review from './Review';

const mapStateToProps = (state: AppState) => ({
	contract: state.contract,
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<any>, void, Action>
) => ({});

const translated = withTranslation('translation')(Review);
export default connect(mapStateToProps, mapDispatchToProps)(translated);
